import {
  signalingBreakoutRoomsStarted,
  splashScreenOpenRequested,
} from 'features/breakout-rooms/actions';
import { roomMovementRequested } from 'features/breakout-rooms/breakoutRoomsSlice';
import { call, put } from 'redux-saga/effects';
import { RTCClient } from 'utils/webrtc';
import { hasPermissionsSaga } from 'features/permissions/sagas/hasPermissionsSaga';
import { PermissionTypes } from 'features/permissions/types';
import { broadcastSetupStarted } from 'features/room/roomSlice';

export function* onBreakoutRoomsStartedSaga(
  action: ReturnType<typeof signalingBreakoutRoomsStarted>
) {
  if (action.payload) {
    yield put(splashScreenOpenRequested(action.payload.reason));

    yield call(RTCClient.setBreakoutRoomId, action.payload.targetRoom.id);

    yield put(roomMovementRequested());

    const broadcastAllowed: boolean = yield call(
      hasPermissionsSaga,
      [PermissionTypes.broadcastAudio, PermissionTypes.broadcastVideo],
      {
        mode: 'any',
      }
    );

    if (!broadcastAllowed) {
      yield put(broadcastSetupStarted({ reason: 'breakout' }));
    }
  }
}
